import { CommonTooltips } from "@mcleod/common";
import { OrderTabView } from "@mcleod/dispatch";
import { AutogenLayoutWireFundsTable } from "./autogen/AutogenLayoutWireFundsTable";
import { DataSourceExecutionEvent, Label, TableRowDisplayEvent } from "@mcleod/components";

const ORDER_FIELD = "order_id";

export class WireFundsTable extends AutogenLayoutWireFundsTable {

    unpostedWireBeforeExecution(event: DataSourceExecutionEvent) {
        const table = event.target.owner as WireFundsTable;
        const filter = this.getFilterForTable(table.id);
        event.filter.status = filter;
    }

    getFilterForTable(tableId: string): string {
        if (tableId.includes("Unverified")) {
            return "U";
        } else if (tableId.includes("Hold")) {
            return "H";
        } else if (tableId.includes("Void")) {
            return "V";
        } else {
            return "P"; // Ready
        }
    }

    /** This is an event handler for the onRowDisplay event of tableWireFundsProcessing. */
    tableWireFundsProcessingOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const orderLabel = tableRow.findComponentById("labelOrderId")
        const orderId = tableRow.data.get(ORDER_FIELD);
        if (orderId) {
            this.setupOrderLink(tableRow.findComponentsByField(ORDER_FIELD)[0] as Label, orderId);
        } else {
            orderLabel.visible = false;
            orderLabel.enabled = false;
        }
    }

    setupOrderLink(comp: Label, orderId) {
        comp.applyLinkStyle();
        comp.addClickListener(() => {
            OrderTabView.navigateTo({ key: orderId, newTab: true });
        });
    }

}
